import React from "react";

const STEPS = [
	{ status: "validating_url", label: "Validate URL" },
	{ status: "validating_url", label: "Research site description(LLM)" },
	{ status: "discovering_pages", label: "Crawl the page" },
	{ status: "classifying_pages", label: "Categorize links (LLM)" },
	{ status: "fetching_pages", label: "Fetch metadata" },
	{ status: "generating_llms_txt", label: "Build llms.txt" },
	{ status: "completed", label: "Complete" },
];

const STATUS_ORDER = [
	"pending",
	"validating_url",
	"discovering_pages",
	"classifying_pages",
	"fetching_pages",
	"generating_llms_txt",
	"completed",
];

function statusIndex(status) {
	const idx = STATUS_ORDER.indexOf(status);
	return idx === -1 ? 0 : idx;
}

export default function LlmsTxtPipelineSteps({
	status,
	lastStage,
	pagesTotal,
	pagesExtracted,
	progress,
}) {
	const effectiveStatus =
		status === "failed" && lastStage ? lastStage : status || "pending";
	const currentIdx = statusIndex(effectiveStatus);
	const failed = status === "failed";

	return (
		<div className="llms-txt__pipeline">
			{progress != null && progress > 0 && progress < 100 && (
				<div className="llms-txt__progress mb-3">
					<div className="llms-txt__progress-bar">
						<div
							className="llms-txt__progress-fill"
							style={{ width: `${progress}%` }}
						/>
					</div>
					<p className="llms-txt__progress-label text-muted small mb-0">{progress}%</p>
				</div>
			)}
			<ol className="llms-txt__pipeline-steps list-unstyled mb-0">
				{STEPS.map((step) => {
					const stepIdx = statusIndex(step.status);
					const isComplete = !failed && currentIdx > stepIdx;
					const isCurrent = !failed && currentIdx === stepIdx;
					const isFailedStep = failed && currentIdx === stepIdx;
					// const isPending = !isComplete && !isCurrent && !isFailedStep;

					const showFetchProgress =
						step.status === "fetching_pages" &&
						isCurrent &&
						pagesTotal != null &&
						pagesExtracted != null;

					let iconClass = "far fa-circle text-muted";
					if (isComplete) iconClass = "fas fa-check-circle text-success";
					if (isCurrent) iconClass = "fas fa-spinner fa-spin text-primary";
					if (isFailedStep) iconClass = "fas fa-times-circle text-danger";

					let textClass = "text-muted";
					if (isComplete) textClass = "text-success fw-medium";
					if (isCurrent) textClass = "text-primary fw-medium";
					if (isFailedStep) textClass = "text-danger fw-medium";

					return (
						<li key={step.status} className="llms-txt__pipeline-step d-flex align-items-center gap-2">
							<i className={`${iconClass} llms-txt__pipeline-icon`} aria-hidden="true" />
							<span className={`small ${textClass}`}>
								{step.label}
								{showFetchProgress && (
									<span className="ms-2 fw-normal">
										({pagesExtracted} / {pagesTotal} links)
									</span>
								)}
							</span>
						</li>
					);
				})}
			</ol>
		</div>
	);
}
